import { Link } from "react-router-dom";
// import ChooseSection from "../../components/ChooseSection/ChooseSection";
import "./Home.css";
// import { Card } from "react-bootstrap";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import SliderInfo from "../../components/caraousel/SliderInfo";
// import Blog1Img from "../../utils/images/School_Award1.jpg";
// import Hero2 from "../../utils/images/School_FrontBoundary.jpg";
import Hero1 from "../../utils/images/home-hero1.png";
// import Hero2 from "../../utils/images/hero1crop.png";
import Hero2 from "../../utils/images/hero3.jpeg";
// import Hero3 from "../../utils/images/School_StudentCouncil.jpg";
import Hero3 from "../../utils/images/hero2.PNG";
import EventShowcase from "../../components/event/EventShowcase";
import HallOfFame from "../../components/hallOfFame/HallOfFame";
import LatestAchievements from "../../components/latest-achievements/LatestAchievements";
import Facilities from "../../components/our-facilities/Facilities";

// const blogs = [
//   {
//     id: 1,
//     img: [Blog1Img],
//     title: "Iqraa Public School Awarded AAA+ Rating for 2024",
//     description:
//       "Iqraa Public School, Fatehpur Taga, has been recognized as one of India's best schools by Careers360, receiving an *AAA+ rating* in the *Day School* category for the academic year 2023-24. This achievement highlights the school's dedication to academic excellence, quality faculty, and outstanding infrastructure.",
//   },
// ];

const slides = [
  {
    image: Hero1,
    title1: "Welcome To",
    title2: "IQRAA PUBLIC SCHOOL",
    subtitle: "Affiliated to CBSE",
    description: '"A Journey through Knowledge and Discovery"',
    buttonText: "Contact Us",
    buttonLink: "/contact",
  },
  {
    image: Hero2,
    title2: "A School Where Dreams Take Flight",
    description:
      "At IPS, we cultivate excellence, spark creativity, and build values that guide learners toward meaningful success.",
  },
  {
    image: Hero3,
    title2: "Experience World-Class Learning",
    description: "Where technology meets creativity and purpose.",
  },
];

function Home() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);
  return (
    <div className="home-page">
      {/* <header className='h-100 min-vh-100 d-flex align-items-center text-light'> */}
      {/* <header className='height-75 d-flex align-items-center text-light'>
            <div className='container d-flex flex-column align-items-center'>
                <h2>Welcome To</h2>
                <h1 className='text-center fw-semibold'>IQRAA PUBLIC SCHOOL</h1>
                <h2 className='text-cente'>Affiliated to CBSE</h2><br/>
                <h2 className='text-center text-success'>"A Journey through Knowledge and Discovery"</h2>
                
                <div className='d-flex flex-column flex-sm-row align-items-center'>
                   <Link to="/contact">
                        <button type='button' className='btn btn-success btn-lg mx-0 mx-sm-2 my-2 my-sm-0'>Contact Us</button>
                    </Link>
                </div>
            </div>
        </header> */}

      <div className="hero-carousel">
        <AnimatePresence>
          <motion.img
            key={slides[index].image}
            src={slides[index].image}
            alt=""
            className="hero-image"
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          />
        </AnimatePresence>

        <div className="hero-overlay" />

        <div className="hero-content">
          {slides[index].title1 && (
            <motion.h2
              key={slides[index].title1}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              {slides[index].title1}
            </motion.h2>
          )}

          <motion.h1
            key={slides[index].title2}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {slides[index].title2}
          </motion.h1>

          {slides[index].subtitle && (
            <motion.h3
              key={slides[index].subtitle}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {slides[index].subtitle}
            </motion.h3>
          )}

          <motion.p
            key={slides[index].description}
            className="hero-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            {slides[index].description}
          </motion.p>

          {slides[index].buttonText && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <Link to={slides[index].buttonLink}>
                <motion.button
                  className="btn btn-success btn-lg mt-3"
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {slides[index].buttonText}
                </motion.button>
              </Link>
            </motion.div>
          )}
        </div>

        <div className="hero-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={i === index ? "dot active" : "dot"}
            />
          ))}
        </div>
      </div>

      <div className="section-gradient">
        {/* <ChooseSection /> */}
        <EventShowcase />
      </div>

      <div className="section-gradient">
        <HallOfFame />
      </div>

      <div className="section-gradient">
        <Facilities />
      </div>

      {/* <SliderInfo /> */}

      {/* <div className='py-5 section-gradient'>
            <div className="container">
                
                <div className='row d-flex align-items-center justify-content-around'>
                    <div className='col-lg-5'>
                        <h2 className='text-capitalize'>2024 start courses</h2>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus, placeat.</p>
                        <Link to="/courses">
                            <button type='button' className='btn btn-danger btn-lg mx-0 mx-sm-2 my-2 my-sm-0'>Learn More</button>
                        </Link>
                    </div>
                    <div className='col-lg-5 mt-5 mt-lg-0'>
                        <img src={StartCoursesImg} className='img-fluid' alt="" />
                    </div>
                </div>
            </div>
        </div> */}

      {/* <div className="py-5">
            <FaqAccordion />
        </div> */}

      <div className="section-gradient">
        <LatestAchievements />
      </div>
    </div>
  );
}

export default Home;
